<app-toolbar color="primary" [scrollableElement]="scrollContainer">
  <a routerLink="/" title="Zurück">
    <app-fs-logo />
    <span>Zurück zur Homepage</span>
  </a>
</app-toolbar>

<div class="container" #scrollContainer>
  @if (inhalt$ | async; as inhalt) {
    <h1>{{ inhalt.title }}</h1>
    <markdown [content]="inhalt.content" class="content"></markdown>
  }
</div>
